"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    primary: "Montserrat, sans-serif"
};
// Path: src/tokens/typography/family.ts
//# sourceMappingURL=family.js.map